import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { getDataOnFromTheme, WorkbenchTheme } from '../../shared/themes';

/** @slot - wb-subnavigation-item elements */
@Component({
  tag: 'wb-subnavigation',
  styleUrl: 'subnavigation.scss',
  shadow: true,
})
export class SubnavigationComponent implements ComponentInterface {
  @Element()
  public el!: HTMLElement;

  /**
   * colour scheme
   * @deprecated Use `data-on` attribute instead
   * */
  @Prop({ reflect: true })
  public theme: WorkbenchTheme;

  /** aligns the items horizontally or vertically */
  @Prop({ reflect: true })
  public direction: 'horizontal' | 'vertical' = 'horizontal';

  public render(): JSX.Element {
    return (
      <Host class="wb-subnavigation" role="navigation" data-on={getDataOnFromTheme(this.el, this.theme)}>
        <slot />
      </Host>
    );
  }
}
